import Vue from 'vue'
import _ from 'lodash';

Vue.filter('_0toEmpty', (value: any) => {
  return value === 0 ? '' : value
});
